export default {
    //判断是否为空 
    isEmpty: function(data) {
        if ((data == '' || data == null || data == undefined || data == 'null') && data !== 0) {
            return true;
        } else {
            return false;
        }
    },
    //解决对象的浅拷贝
    copyObj: function(obj) {
        return JSON.parse(JSON.stringify(obj))
    },
    formatTel:function(tel) {
        var reg = /^(\d{3})\d{4}(\d{4})$/;
        return tel.replace(reg, "$1****$2");
    }
}